var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex justify-center sm:ml-2" }, [
    _c("div", { staticClass: "w-full pt-4" }, [
      _c(
        "div",
        { staticClass: "relative shadow-sm" },
        [
          _c("resize-auto", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ resize }) {
                  return [
                    _c("FormTextarea", {
                      ref: "message",
                      staticClass:
                        "min-h-11 px-4 py-3 text-primary-black text-base border bg-transparent rounded-lg overflow-y-hidden",
                      attrs: {
                        disabled: _vm.textareaDisabled,
                        placeholder: "Message here",
                        rows: 1,
                      },
                      on: { keydown: _vm.enter, input: (_, e) => resize(e) },
                      model: {
                        value: _vm.input,
                        callback: function ($$v) {
                          _vm.input = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "input",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("div", { staticClass: "absolute right-5 inset-y-0 flex" }, [
            _c("input", {
              ref: "attachment",
              attrs: { type: "file", hidden: "" },
              on: { change: _vm.newAttachment },
            }),
            _c(
              "button",
              {
                staticClass:
                  "cursor-pointer flex items-center text-gray-400 hover:text-gray-500 mr-5 focus:outline-none",
                attrs: { type: "button" },
                on: { click: _vm.upload },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "17",
                      height: "19",
                      viewBox: "0 0 17 19",
                      fill: "none",
                    },
                  },
                  [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_58_35868)" } },
                      [
                        _c("path", {
                          attrs: {
                            d: "M13.5151 3.10978C12.6097 2.20431 11.1401 2.20431 10.2347 3.10978L3.40654 9.9379C1.84424 11.5002 1.84424 14.0311 3.40654 15.5934C4.96885 17.1557 7.49971 17.1557 9.06201 15.5934L14.7026 9.95275C15.1071 9.54825 15.7677 9.54825 16.1722 9.95275C16.5767 10.3572 16.5767 11.0178 16.1722 11.4223L10.5315 17.0629C8.15654 19.4379 4.31201 19.4379 1.93701 17.0629C-0.437988 14.6879 -0.437988 10.8434 1.93701 8.46837L8.76514 1.64025C10.4833 -0.0779175 13.2665 -0.0779175 14.9847 1.64025C16.7028 3.35841 16.7028 6.14161 14.9847 7.85978L8.45342 14.391C7.39209 15.4524 5.67021 15.4524 4.60889 14.391C3.54756 13.3297 3.54756 11.6078 4.60889 10.5465L9.95264 5.20275C10.3571 4.79825 11.0177 4.79825 11.4222 5.20275C11.8267 5.60724 11.8267 6.26779 11.4222 6.67228L6.07842 12.016C5.82979 12.2647 5.82979 12.6729 6.07842 12.9215C6.32705 13.1701 6.73525 13.1701 6.98389 12.9215L13.5151 6.39025C14.4206 5.48478 14.4206 4.01525 13.5151 3.10978Z",
                            fill: "#717986",
                          },
                        }),
                      ]
                    ),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_58_35868" } }, [
                        _c("rect", {
                          attrs: {
                            width: "16.625",
                            height: "19",
                            fill: "white",
                          },
                        }),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass:
                  "cursor-pointer flex items-center text-gray-400 hover:text-gray-500 focus:outline-none",
                attrs: { type: "submit" },
                on: { click: _vm.submit },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "17",
                      height: "18",
                      viewBox: "0 0 17 18",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M8.898 8.8116C8.75993 8.64596 5.93293 8.09913 3.80053 7.7128C3.02637 7.57255 2.36719 7.06736 2.03596 6.35372L0.223212 2.44808C0.0761742 2.13128 -0.0138537 1.78346 0.0342278 1.43752C0.178545 0.399198 0.751439 0.0610414 1.21769 0.00783055C1.45108 -0.0188062 1.67554 0.076784 1.88278 0.187393L15.4297 7.41756C15.5762 7.49575 15.7329 7.55501 15.8873 7.61594C17.2269 8.14437 17.1508 9.45456 16.7231 9.98168C16.646 10.0767 16.5379 10.1386 16.43 10.1963L2.72408 17.5175C2.62395 17.571 2.52858 17.6331 2.43346 17.6952L2.41646 17.7062C1.36955 18.3883 0.681756 17.7672 0.303386 17.0183C0.0378462 16.4927 0.159763 15.875 0.448928 15.362L2.29817 12.0815C2.66426 11.4321 3.31206 10.9944 4.03868 10.8277C6.10353 10.354 8.7588 9.43918 8.898 9.31394C9.06549 9.16324 8.96778 8.91625 8.898 8.8116Z",
                        fill: "#717986",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm.attachment
        ? _c("div", { staticClass: "flex my-2 mx-2 text-sm" }, [
            _c(
              "span",
              {
                staticClass:
                  "relative border border-primary-500 py-1 pl-4 pr-8",
              },
              [
                _vm._v(" " + _vm._s(_vm.attachment.name) + " "),
                _c("button", {
                  staticClass:
                    "cursor-pointer w-5 h-5 text-center absolute right-0 mdi mdi-close mr-1 hover:bg-gray-200",
                  attrs: { type: "button" },
                  on: { click: _vm.removeAttachment },
                }),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }